// this file is automatically generated by version.generator.ts script
export const versions = {
  version: '4.88.0-beta.8130afae',
  revision: '8130afae',
  branch: 'develop',
  date: 'Thu, 02 Apr 2026 14:06:58 GMT'
};